import { module } from 'modujs';
import Swiper, { Navigation, Lazy, Keyboard, Mousewheel } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m)

        // UI
        this.$el = this.el
        this.$container = this.$('container')[0]
        this.$buttonNext = this.$('next')[0]
        this.$buttonPrev = this.$('prev')[0]

        // Data
        this.length = this.$('item').length
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.carousel = null

        Swiper.use([ Navigation, Lazy, Keyboard, Mousewheel ]);

        const args = {
            spaceBetween: 20,
            slidesPerView: 'auto',
            grabCursor: true,
            centeredSlides: true,
            loop: true,
            preloadImages: false,
            slideToClickedSlide: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 2,
            },
            navigation: {
                prevEl: this.$buttonPrev,
                nextEl: this.$buttonNext
            },
            a11y: {
                prevSlideMessage: 'Previous photo',
                nextSlideMessage: 'Next photo',
                containerMessage: 'Gallery of decorative images'
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            mousewheel: {
                forceToAxis: true
            },
            on: {
                init: () => {
                    this.call('update', null, 'Scroll')
                }
            }
        }

        if (this.length > 1) {
            this.carousel = new Swiper(this.$container, args)
        }
    }

    destroy() {
        super.destroy()
        this.carousel?.destroy(true, true)

        if (this.hasCursor) {
            this.$container.removeEventListener('mouseenter', this.onMouseEnterBind)
            this.$container.removeEventListener('mouseleave', this.onMouseLeaveBind)
            this.$container.removeEventListener('mousemove', this.onMouseMoveBind)
        }
    }
}
